import {
  createDataReducer,
  getDataReducerInitialState,
} from "@ea/shared_components/redux/reducers/common.data.reducer";

import { Documentation } from "@ea/shared_types/types";
import { moduleActions } from "./documentation.actions";

const initialState = {
  ...getDataReducerInitialState<Documentation>(),
};

export type DocumentationReducer = typeof initialState;

const dataReducer = createDataReducer<Documentation>({
  ...moduleActions.table,
  ...moduleActions.data,
});

export const reducer = dataReducer(initialState);
